<template>
	<div>
		<el-tree
			:data="treeData"
			:default-expand-all="false"
			:props="defaultProps"
			ref="myTree"
			:render-content="renderContent"
			accordion
			@node-click="handleNodeClick"
			:expand-on-click-node="false"
		></el-tree>
	</div>
</template>

<script>
export default {
	name: 'tRee',
	data() {
		return {
			totalLevels: 0
		};
	},
	props: ['treeData', 'defaultProps'],
	methods: {
		handleNodeClick(data, node) {
			console.log(data, node, 77778888);
			let classificationId = data.resourceClassificationId || data.classificationId;
			sessionStorage.setItem('classificationId', classificationId);
			// 执行节点点击后的操作
			this.$emit('perList', {
				classificationId,
				pageNum: 1,
				pageSize: 10
			});
			// if(this.totalLevels==0){
			//   this.calculateTotalLevels(this.treeData,1)
			// }
			// if (node.level === this.totalLevels) {
			//   // 执行节点点击后的操作
			//   this.$emit('perList', {
			//     classificationId: data.resourceClassificationId || data.classificationId,
			//     pageNum: 1,
			//     pageSize: 10,
			//   })
			//   console.log('最后一级节点被点击', data);
			// }
		},
		calculateTotalLevels(nodes, level) {
			if (nodes && nodes.length) {
				this.totalLevels = Math.max(this.totalLevels, level);
				console.log(this.totalLevels, 8888);
				nodes.forEach((node) => {
					if (node.children && node.children.length) {
						this.calculateTotalLevels(node.children, level + 1);
					}
				});
			}
		},
		renderContent(h, { node, data }) {
			console.log(node, data, 9999, this.defaultProps.label);
			return h(
				'span',
				{
					style: `font-weight: ${node.childNodes.length == 0 ? '' : 'bold'};color: ${node.childNodes.length == 0 ? '#606266' : '#000'};display: inline-block;width: ${
						180 - (node.level - 1) * 20
					}px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;`,
					attrs: { title: data[this.defaultProps.label] }
				},
				[data[this.defaultProps.label]]
			);
		}
	},
	mounted() {
		this.$nextTick(() => {});
	}
};
</script>
<style lang="scss" scoped>
a {
	display: inline-block;
}
</style>
